module.exports = __webpack_public_path__ + "img/product_img_bg_big.e3135cf.webp";